import React from 'react';

import GhaInfoContainer from '../../forwarderImport/ghaInfo/GhaInfoContainer';

interface GhaHeaderProps {
  ghaId: number;
  type: string;
};

const GhaHeader = (props: GhaHeaderProps) => {

  return (
    <GhaInfoContainer ghaId={ props.ghaId } type={ props.type }/>
  );
}

export default GhaHeader;
